import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';

import {
  setSelectedSector,
  setSelectedCountry,
  resetScrollCountry,
  setActiveSoeDataType,
  setActiveSoePane,
} from '../../../actions';
import {
  getSectorChart,
  getSectorGraph,
  getMarketCapChart,
  getMaturityChart,
  getCreditQualityChart,
  getAssetClassChart,
  getCountryBarChart,
  getRegionChart,
  getCountryLineChart,
  getUniqueCountries,
  // getSortedCountries,
  // getStyleBoxChart,
  // getStyleT,
  // getStyleT2,
  getGeoRevZoneChart,
  // getGicsTreeMapOption,
  // getGicsSankeyOption,
} from '../charts.js';
import SoeRow from '../Soe/SoeRow';
import './Exposures.css';
import i18n from '../../../i18n';
import CompText from '../Compliance/CompText';
import Select from 'react-select';
import SubIndustry from './SubIndustry.js';
import GicsTreeMap from './GicsTreeMap.js';

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0,
    border: '1px solid #050139', // default border color
    boxShadow: 'none',
  }),
  option: (provided) => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#050139',
      color: 'white',
    },
    overflowY: 'hidden',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 0,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 100ms';
    return { ...provided, opacity, transition };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: '#050139',
  }),
};

// // GICS drill levels
// const GICS_LEVELS = ['sector', 'ig', 'industry', 'subIndustry'];
// const GICS_LEVEL_LABELS = {
//   sector: 'Sectors',
//   ig: 'Industry Groups',
//   industry: 'Industries',
//   subIndustry: 'Sub-Industries',
// };

class Exposures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreChars: false,
      chartType: { value: 'SOE', label: 'SOE' },
      SOECatType1: { value: 'SOE', label: 'SOE' },
      SOECatType2: { value: 'SOE', label: 'SOE' },
      showGrid: false,
      selectedCountry: '',
      selectedFundId: '',
    };
  }

  updateHighlight = (ticker, highlight = true) => {
    // 1) Bail out if the chart isn’t ready yet
    if (!this.chartInstance) return;

    // 2) Decide how big to make the circles, and what border style to apply
    const newRadius = highlight ? 10 : 6;
    const newStyle = highlight
      ? { lineWidth: 2, stroke: 'gold' } // gold border when highlighted
      : { lineWidth: 1, stroke: null }; // normal border otherwise

    // 3) Tell ECharts to update BOTH matching graphics elements
    //    (growth-<ticker> is the horizontal dot, size-<ticker> the vertical one)
    this.chartInstance.setOption({
      graphic: [
        { id: `growth-${ticker}`, shape: { r: newRadius }, style: newStyle },
        { id: `size-${ticker}`, shape: { r: newRadius }, style: newStyle },
      ],
    });
  };
  // toggleGridView = () => {
  //   this.setState((s) => ({ showGrid: !s.showGrid }));
  // };

  calculateCountryExposure(country, countryData) {
    let totalExposure = 0;
    countryData.forEach((fund) => {
      const exposure =
        fund.countryExposures?.[fund.countryExposures.length - 1];
      if (exposure && exposure.keys && exposure.values) {
        const idx = exposure.keys.indexOf(country);
        if (idx !== -1) {
          totalExposure += parseFloat((exposure.values[idx] * 100).toFixed(2));
        }
      }
    });
    return totalExposure.toFixed(2);
  }
  // Toggling logic to set or clear the selected country.
  handleBarChartClick = (params) => {
    // params.name should be the country clicked on.
    this.setState((prevState) => ({
      selectedCountry:
        prevState.selectedCountry === params.name ? '' : params.name,
    }));
  };

  // Function to update the selected country if needed by a child.
  setSelectedCountry = (country) => {
    this.setState({ selectedCountry: country });
  };

  toggleGridView = () => {
    this.setState((prevState) => ({ showGrid: !prevState.showGrid }));
  };

  handleChartTypeChange = (chartType) => {
    this.setState({ chartType: chartType });
  };

  handleFundChange = (opt) => {
    this.setState({ selectedFundId: opt ? opt.value : '' });
  };
  setActiveSoePane(val) {
    this.props.setActiveSoePane(val);
  }

  scrollCountry() {
    if (this.props.scrollCountry) {
      const elem = document.getElementById('country');
      elem.scrollIntoView();
      this.props.resetScrollCountry();
    }
    return true;
  }

  asOfDate(name, data) {
    const fund = data[0];
    const value =
      fund[name] && fund[name][fund[name].length - 1]
        ? fund[name][fund[name].length - 1]
        : undefined;
    if (value && value.date) {
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0];
    } else {
      return new Date().toLocaleString().split(',')[0].split(' ')[0]; // returns the current date
    }
  }

  getAllIndexes(arr, val) {
    var indexes = [],
      i = -1;
    while ((i = arr.indexOf(val, i + 1)) !== -1) {
      indexes.push(i);
    }
    return indexes;
  }

  consolidatedCountry(data) {
    return data;
  }

  getSubTotals(array) {
    let sum = 0;
    for (let i = 0; i < array.length; i++) {
      sum += array[i];
    }
    return sum;
  }

  getSortedKeys(data, type) {
    let xDataCloned = JSON.parse(JSON.stringify(data));
    let xData = this.getSortedData(xDataCloned);
    let keys = xData.keys;
    if (type === 'Sector') {
      return keys;
    } else if (type === 'Country') {
      if (keys.length <= 10) {
        return keys;
      } else {
        let y = keys.slice(0, 10);
        y.push('Other');
        return y;
      }
    }
  }

  getSortedData(data) {
    //simple desc sort on values array
    let keys = [...data.keys];
    let values = [...data.values];
    const ix = keys.map((x, i) => i);
    ix.sort((a, b) => values[b] - values[a]);
    values = ix.map((x) => values[x]);
    keys = ix.map((x) => keys[x]);
    data.keys = keys;
    data.values = values;
    return data;
  }

  getTableData(data2) {
    const { data, activeSoeDataType } = this.props;

    //get keys that will be used on Summary tab
    let sumKeys = [];
    let topKeys = [];
    // let otherKeys = [];
    const soeData = data.filter((x) => x.countryExposuresSOESummary !== null);

    if (activeSoeDataType === 'Country') {
      sumKeys = this.getSortedData(
        soeData[0].countrySOESubTotals[
          soeData[0].countrySOESubTotals.length - 1
        ]
      ).keys;
      //keep summary keys & divide SOE/NON SOE data if > 10
      topKeys = sumKeys.slice(0, 10);
      // if (sumKeys.length > 10) {
      //   otherKeys = sumKeys.slice(10, sumKeys.length);
      // }

      //divide incoming data if greater than 10 into top 10 & other -  order s/b same as summary tab
      let keys = [...data2.keys];
      let values = [...data2.values];
      let founds = [];
      let oValues = [];
      let oKeys = [];
      let tValues = [];
      let tKeys = [];
      keys.forEach((x, i) => {
        const found = topKeys.indexOf(x);
        if (found !== -1) {
          founds.push(i);
          tValues.push(values[i]);
          tKeys.push(keys[i]);
        } else {
          oValues.push(values[i]);
          oKeys.push(keys[i]);
        }
      });

      const oTotal = oValues.reduce((acc, ele) => acc + ele, 0);
      tKeys.push('Other');
      tValues.push(oTotal);
      data2.keys = tKeys;
      data2.values = tValues;
      return data2;
    } else if (activeSoeDataType === 'Sector') {
      sumKeys = this.getSortedData(
        soeData[0].sectorSOESubTotals[soeData[0].sectorSOESubTotals.length - 1]
      ).keys;
      return data2;
    }
  }

  getLevelData(data, constituent, level, type) {
    const { activeSoeDataType, activeSoePane } = this.props;

    let filteredData = data.map((fund, i) => {
      let xData = [];
      if (activeSoeDataType === 'Sector') {
        if (activeSoePane === 'Summary') {
          //copy data to avoid mutating original Other will duplicate
          if (type === 'SUM') {
            let yxData =
              fund.sectorSOESubTotals[fund.countrySOESubTotals.length - 1];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          } else if (type === 'SOE') {
            let yxData =
              fund.sectorExposuresSOE[fund.sectorExposuresSOE.length - 1];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          } else if (type === 'NONSOE') {
            let yxData =
              fund.sectorExposuresNonSOE[fund.sectorExposuresNonSOE.length - 1];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          }
        } else if (activeSoePane === 'Details-SOE') {
          let yxData =
            fund.sectorExposuresSOE[fund.sectorExposuresSOE.length - 1];
          let xDataCloned = JSON.parse(JSON.stringify(yxData));
          xData = this.getTableData(xDataCloned);
        } else if (activeSoePane === 'Details-NonSOE') {
          let yxData =
            fund.sectorExposuresNonSOE[fund.sectorExposuresNonSOE.length - 1];
          let xDataCloned = JSON.parse(JSON.stringify(yxData));
          xData = this.getTableData(xDataCloned);
        }
      } // sector type
      else if (activeSoeDataType === 'Country') {
        if (activeSoePane === 'Summary') {
          if (type === 'SUM') {
            let yxData =
              fund.countrySOESubTotals[fund.countrySOESubTotals.length - 1];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          } else if (type === 'SOE') {
            let yxData =
              fund.countryExposuresSOE[fund.countryExposuresSOE.length - 1];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          } else if (type === 'NONSOE') {
            let yxData =
              fund.countryExposuresNonSOE[
                fund.countryExposuresNonSOE.length - 1
              ];
            let xDataCloned = JSON.parse(JSON.stringify(yxData));
            xData = this.getTableData(xDataCloned);
          }
        } else if (activeSoePane === 'Details-SOE') {
          let yxData =
            fund.countryExposuresSOE[fund.countryExposuresSOE.length - 1];
          let xDataCloned = JSON.parse(JSON.stringify(yxData));
          xData = this.getTableData(xDataCloned);
        } else if (activeSoePane === 'Details-NonSOE') {
          let yxData =
            fund.countryExposuresNonSOE[fund.countryExposuresNonSOE.length - 1];
          let xDataCloned = JSON.parse(JSON.stringify(yxData));
          xData = this.getTableData(xDataCloned);
        }
      } //country type

      var indexes = this.getAllIndexes(xData.keys, constituent);
      let indexData = '';
      if (activeSoePane === 'Summary') {
        indexData = xData.values[indexes[0]];
      } else if (activeSoePane === 'Details-NonSOE') {
        if (type === 'NONSOE') indexData = xData.values[indexes[0]];
        else indexData = this.getSubTotals(xData.values);
      } else if (activeSoePane === 'Details-SOE') {
        if (type === 'SOE') indexData = xData.values[indexes[0]];
        else indexData = this.getSubTotals(xData.values);
      } else indexData = xData.values[indexes[0]];

      return indexData;
    });
    return filteredData;
  }

  renderSoeTableHeader() {
    const { data, activeSoeDataType } = this.props;

    const soeData = data.filter((x) => x.countryExposuresSOESummary !== null);
    const tickerList = data
      .filter((x) => x.countryExposuresSOESummary !== null)
      .map((fund) => {
        if (fund.type === 'BMK') {
          return (
            <th key={fund.ticker} className="textCenter">
              {fund.ticker}
            </th>
          );
        } else {
          return (
            <th key={fund.ticker} className="textCenter">
              {fund.fundPageURL && (
                <a
                  className="tickerLinkFC"
                  href={fund.fundPageURL}
                  target="_new"
                >
                  {fund.ticker}
                </a>
              )}
              {!fund.fundPageURL && (
                <a className="tickerLinkFC" href={fund.msUrl} target="_new">
                  {fund.ticker}
                </a>
              )}
            </th>
          );
        }
      });

    return (
      <Fragment>
        <tr>
          {activeSoeDataType === 'Sector' && (
            <Fragment>
              <th colSpan="14" className="textLeft">
                {i18n.t('State-Ownership & Sector Breakdown (% Weight) ')}{' '}
                {i18n.t('as of')} {this.asOfDate('sectorSOESubTotals', soeData)}
                &nbsp;&nbsp;&nbsp;
              </th>
            </Fragment>
          )}
          {activeSoeDataType === 'Country' && (
            <Fragment>
              <th colSpan="14" className="textLeft">
                {i18n.t('State-Ownership & Country Breakdown (% Weight) ')}{' '}
                {i18n.t('as of')}{' '}
                {this.asOfDate('countrySOESubTotals', soeData)}
                &nbsp;&nbsp;&nbsp;
              </th>
            </Fragment>
          )}
        </tr>
        <tr>
          <th className="textLeft">{activeSoeDataType}</th>
          <th className="textLeft">{'State-Ownership '}</th>
          {tickerList}
        </tr>
      </Fragment>
    );
  }

  renderSoeTableDetails() {
    const { data, activeSoeDataType, activeSoePane } = this.props;

    const soeData = data.filter((x) => x.countryExposuresSOESummary !== null);
    const tickers = data
      .filter((x) => x.countryExposuresSOESummary !== null)
      .map((a) => a.ticker);

    let allConstituentKeys = [];
    let magicArrayToMap = [];

    // get top country keys for first selected fund
    let summaryCountryConstituent = this.getSortedKeys(
      soeData[0].countrySOESubTotals[soeData[0].countrySOESubTotals.length - 1],
      activeSoeDataType
    );
    let summarySectorConstituent = this.getSortedKeys(
      soeData[0].sectorSOESubTotals[soeData[0].sectorSOESubTotals.length - 1],
      activeSoeDataType
    );

    if (activeSoeDataType === 'Country') {
      allConstituentKeys = [...summaryCountryConstituent];
    } else {
      allConstituentKeys = [...summarySectorConstituent];
    }

    if (activeSoePane === 'Summary') {
      allConstituentKeys.forEach((x) => {
        let m0 = {};
        m0.key = x + '-' + 0;
        m0.detailType = '-';
        m0.displayName = x;
        m0.level = '1';
        m0.style = 'blue';
        m0.value = this.getLevelData(soeData, x, 'Summary', 'SUM');
        magicArrayToMap.push(m0);

        let m1 = {};
        m0.key = x + 'SOE' + 1;
        m1.detailType = 'SOE';
        m1.displayName = x;
        m1.level = '2';
        m1.style = 'white';
        m1.value = this.getLevelData(soeData, x, 'Details-SOE', 'SOE');
        magicArrayToMap.push(m1);

        let m2 = {};
        m0.key = x + 'non-SOE' + 2;
        m2.detailType = 'non-SOE';
        m2.displayName = x;
        m2.level = '2';
        m2.style = 'white';
        m2.value = this.getLevelData(soeData, x, 'Details-NonSOE', 'NONSOE');
        magicArrayToMap.push(m2);
      });
    }
    if (activeSoePane === 'Details-SOE') {
      allConstituentKeys.forEach((x) => {
        let m1 = {};
        m1.detailType = 'SOE';
        m1.displayName = x;
        m1.level = '2';
        m1.style = 'white';
        m1.value = this.getLevelData(soeData, x, 'Details-SOE', 'SOE');
        magicArrayToMap.push(m1);
      });
      //add summary in front of array
      let m0 = {};
      m0.key = 'Summary-0';
      m0.detailType = 'SOE';
      m0.displayName = '-';
      m0.level = '1';
      m0.style = 'blue';
      m0.value = this.getLevelData(soeData, 'Summary', 'Summary', 'SUM');
      magicArrayToMap.unshift(m0);
    }

    if (activeSoePane === 'Details-NonSOE') {
      allConstituentKeys.forEach((x) => {
        let m2 = {};
        m2.detailType = 'Non-SOE';
        m2.displayName = x;
        m2.level = '2';
        m2.style = 'white';
        m2.value = this.getLevelData(soeData, x, 'Details-NonSOE', 'NONSOE');
        magicArrayToMap.push(m2);
      });
      //add summary in front of array
      let m0 = {};
      m0.key = 'Summary-0';
      m0.detailType = 'NON-SOE';
      m0.displayName = '-';
      m0.level = '1';
      m0.style = 'blue';
      m0.value = this.getLevelData(soeData, 'Summary', 'Summary', 'SUM');
      magicArrayToMap.unshift(m0);
    }

    return magicArrayToMap.map((metric) => {
      return (
        <SoeRow
          key={metric.key}
          style={metric.style}
          displayName={metric.displayName}
          values={metric.value}
          filter={activeSoePane}
          tickers={tickers}
          type={metric.type}
          detailType={metric.detailType}
        />
      );
    });
  }

  render() {
    const {
      data,
      selectedCountry,
      selectedSector,
      activeSoePane,
      setActiveSoeDataType,
    } = this.props;

    const sectorData = data.filter(
      (x) => x.sectorExposures && x.sectorExposures.length > 0
    );
    const regionData = data.filter(
      (x) => x.regionExposures && x.regionExposures.length > 0
    );
    const geoRevZoneExposures = data.filter(
      (x) => x.geoRevZoneExposures && x.geoRevZoneExposures.length > 0
    );
    // const styleBoxData = data.filter(
    //   (x) => x.styleBoxPlotPoints && x.styleBoxPlotPoints.length > 0
    // );
    const country = data.filter(
      (x) => x.countryExposures && x.countryExposures.length > 0
    );
    const countryData = data.filter(
      (x) => x.countryExposures && x.countryExposures.length > 0
    );

    const creditData = data.filter(
      (x) => x.creditQualityExposures && x.creditQualityExposures.length > 0
    );
    const matureData = data.filter(
      (x) => x.maturityExposures && x.maturityExposures.length > 0
    );
    const gicsIndustrySubExposures = data.filter(
      (x) => x.gicsIndustrySubExposures && x.gicsIndustrySubExposures.length > 0
    );
    const gicsData = data.filter(
      (x) => x.gicsExposureTree && x.gicsExposureTree.length > 0
    );

    // const matureData = data.filter(x => x.maturityExposures !== null)
    const assetData = [];
    const marketData = data.filter(
      (x) => x.marketCapExposures && x.marketCapExposures.length > 0
    );

    const soeData = data.filter(
      (x) =>
        x.countryExposuresSOESummary && x.countryExposuresSOESummary.length > 0
    );

    const dataArrays = [
      sectorData,
      regionData,
      country,
      creditData,
      matureData,
      marketData,
    ];
    const hasExposureData = dataArrays.some((data) => data.length > 0);

    //if we are done fetching data and current loaded data has no exposures
    if (!hasExposureData) {
      return (
        <div>
          <div className="noData">{i18n.t('no-data')} </div>
          <div style={{ marginBottom: '65px' }} />
          <CompText pane="Exposures" />
        </div>
      );
    }

    return (
      <div className="fund-char-exposures">
        {Array.isArray(gicsData) && gicsData.length > 0 && (
          <>
            <div className="chartHeader">
              {i18n.t('gics_tree')} {i18n.t('as of')}{' '}
              {this.asOfDate('sectorExposures', sectorData)}&nbsp;&nbsp;&nbsp;
            </div>

            <GicsTreeMap gicsData={gicsData} />
            <div className="subjectToChangeGicsTree">
              {i18n.t('subject to change')} {i18n.t('gics')} (GICS&reg;).
            </div>
          </>
        )}

        {/* end of Treemap */}
        {sectorData.length > 0 && (
          <div className="row" style={{ marginTop: '0px' }}>
            <div className="chartHeader">
              {i18n.t('SECTOR EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('sectorExposures', sectorData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}>
                {i18n.t('select a sector to view historical data')}
              </span>
            </div>
            <div className="row" style={{ marginBottom: '20px' }}></div>
            <div className="chartContainer">
              <ReactEcharts
                onEvents={{ click: this.props.setSelectedSector }}
                option={getSectorChart(sectorData)}
                theme="default"
                style={{ height: 500 }}
              />
            </div>
            <div className="subjectToChange">
              {i18n.t('subject to change')} {i18n.t('sectors-gics')}{' '}
              (GICS&reg;).
            </div>
            {this.props.selectedSector !== '' && (
              <Fragment>
                <div className="subchartContainer">
                  <ReactEcharts
                    option={getSectorGraph(selectedSector, sectorData)}
                    theme="default"
                    style={{ height: 300 }}
                  />
                </div>
              </Fragment>
            )}
          </div>
        )}

        {gicsIndustrySubExposures.length > 0 && (
          <div>
            <div>
              <SubIndustry />
            </div>
            <div className="subjectToChange">
              {i18n.t('subject to change')} {i18n.t('subindustry-gics')}{' '}
              (GICS&reg;).
            </div>
          </div>
        )}
        {countryData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('COUNTRY EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('countryExposures', countryData)}
              &nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}>
                {i18n.t('select a country to view historical data')}
              </span>
            </div>
            {/* "bar Graph*/}
            <div className="chartContainer" style={{ overflow: 'auto' }}>
              <ReactEcharts
                onEvents={{ click: this.props.setSelectedCountry }}
                option={getCountryBarChart(data)}
                style={{
                  height: getUniqueCountries(countryData).length * 100,
                }}
              />
            </div>
            {/* Drill into line chart for Specific country*/}
            <div id="country">
              {this.props.selectedCountry !== '' && this.scrollCountry() && (
                <div className="subchartContainer">
                  <ReactEcharts
                    option={getCountryLineChart(selectedCountry, countryData)}
                    theme="default"
                    style={{ height: 500 }}
                  />
                </div>
              )}
            </div>

            {/* Table with top 15 per fund */}
            <div
              className="gridToggle"
              style={{ marginTop: 15, marginBottom: 10, textAlign: 'left' }}
            >
              <span
                style={{
                  color: 'blue',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onClick={this.toggleGridView}
              >
                {this.state.showGrid
                  ? i18n.t('hide country table')
                  : i18n.t('see country table')}
              </span>
            </div>

            {this.state.showGrid && (
              <div
                className="gridContainer"
                style={{ marginTop: 20, overflowX: 'auto' }}
              >
                <div className="fund-char-details">
                  <table className="tableFC">
                    <thead>
                      {/* First header row: each fund gets a header spanning two columns with extra padding */}
                      <tr>
                        {countryData.map((fund) => (
                          <th
                            key={fund.ticker}
                            colSpan={2}
                            className="textCenter"
                            style={{
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                              textAlign: 'center',
                              lineHeight: '3.5',
                              borderLeft: '1px solid white',
                              // add horizontal padding to create space between fund groups
                              padding: '0 20px',
                            }}
                          >
                            {fund.ticker}
                          </th>
                        ))}
                      </tr>
                      {/* Second header row: two sub-columns for each fund */}
                      <tr>
                        {countryData.map((fund) => (
                          <React.Fragment key={fund.ticker}>
                            <th className="textLeft">Country</th>
                            <th className="textCenter">Weight (%)</th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from({ length: 25 }).map((_, rowIndex) => (
                        <tr key={rowIndex}>
                          {countryData.map((fund) => {
                            // Get the latest exposures data from the fund.
                            const exposure =
                              fund.countryExposures &&
                              fund.countryExposures.length
                                ? fund.countryExposures[
                                    fund.countryExposures.length - 1
                                  ]
                                : null;
                            // Build a list of objects {country, weight} then sort descending by weight.
                            let sortedExposures = [];
                            if (exposure && exposure.keys && exposure.values) {
                              sortedExposures = exposure.keys.map(
                                (country, idx) => ({
                                  country,
                                  weight: parseFloat(
                                    (exposure.values[idx] * 100).toFixed(2)
                                  ),
                                })
                              );
                              sortedExposures.sort(
                                (a, b) => b.weight - a.weight
                              );
                            }
                            // For this row, get the entry if available.
                            const entry = sortedExposures[rowIndex] || {};
                            return (
                              <React.Fragment
                                key={`${fund.ticker}-${rowIndex}`}
                              >
                                <td className="textLeft">
                                  {entry.country || '-'}
                                </td>
                                <td className="textCenter">
                                  {entry.weight !== undefined
                                    ? `${entry.weight}%`
                                    : '-'}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="subjectToChange" style={{ marginTop: 15 }}>
              {i18n.t('subject to change')}
            </div>
          </div>
        )}

        {regionData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('REGION EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('regionExposures', regionData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getRegionChart(regionData)}
                theme="default"
                style={{ height: 400 }}
              />
              <div className="subjectToChange">
                {i18n.t('subject to change')}
              </div>
            </div>
          </div>
        )}

        {geoRevZoneExposures.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('GEO REV REGION EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('geoRevZoneExposure', geoRevZoneExposures)}
              &nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getGeoRevZoneChart(geoRevZoneExposures)}
                theme="default"
                style={{ height: 400 }}
              />
              <div className="subjectToChange">
                {i18n.t('subject to change')}
              </div>
            </div>
          </div>
        )}

        {creditData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('CREDIT PROFILE EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('creditQualityExposures', creditData)}
              &nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getCreditQualityChart(creditData)}
                theme="default"
                style={{ height: 500 }}
              />
            </div>
            <div className="subjectToChange">
              {i18n.t('subject to change')} {i18n.t('comp-cred-quality')}
            </div>
          </div>
        )}

        {matureData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('MATURITY PROFILE EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('maturityExposures', matureData)}&nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getMaturityChart(matureData)}
                theme="default"
                style={{ height: 400 }}
              />
              <div className="subjectToChange">
                {i18n.t('subject to change')} {i18n.t('comp-bond')}
              </div>
            </div>
          </div>
        )}

        {assetData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('ASSET CLASS EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('assetClassExposures', assetData)}
              &nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getAssetClassChart(assetData)}
                theme="default"
                style={{ height: 400 }}
              />
              <div className="subjectToChange">
                {i18n.t('subject to change')}
              </div>
            </div>
          </div>
        )}

        {marketData.length > 0 && (
          <div>
            <div className="chartHeader">
              {i18n.t('MARKET CAP EXPOSURE (% WEIGHT)')} {i18n.t('as of')}{' '}
              {this.asOfDate('marketCapExposures', marketData)}
              &nbsp;&nbsp;&nbsp;
              <span style={{ fontStyle: 'italic' }}></span>
            </div>
            <div className="chartContainer">
              <ReactEcharts
                option={getMarketCapChart(marketData)}
                theme="default"
                style={{ height: 400 }}
              />
              <div className="subjectToChange">
                {' '}
                {i18n.t('subject to change')}
              </div>
            </div>
          </div>
        )}

        {soeData.length > 0 && (
          <div>
            <div className="row" style={{ marginBottom: '20px' }}>
              <div
                className="col-md-3"
                style={{ textAlign: 'center', paddingRight: '3px' }}
              >
                <Select
                  options={[
                    { value: 'Country', label: 'Country' },
                    { value: 'Sector', label: 'Sector' },
                  ]}
                  styles={customStyles}
                  isMulti={false}
                  onChange={setActiveSoeDataType}
                  defaultValue={[{ value: 'Country', label: 'Country' }]}
                />
              </div>
            </div>
            <div className="row listoptions">
              <div className={'col-md-12 col-sm-12 types'}>
                <button
                  onClick={() => this.setActiveSoePane('Summary')}
                  type="button"
                  className={`navSoeButton ${
                    activeSoePane === 'Summary' ? 'isselected' : 'notselected'
                  }`}
                >
                  {i18n.t('Summary')}
                </button>
                <button
                  onClick={() => this.setActiveSoePane('Details-SOE')}
                  type="button"
                  className={`navSoeButton ${
                    activeSoePane === 'Details-SOE'
                      ? 'isselected'
                      : 'notselected'
                  }`}
                >
                  {i18n.t('SOE')}
                </button>
                <button
                  onClick={() => this.setActiveSoePane('Details-NonSOE')}
                  type="button"
                  className={`navSoeButton ${
                    activeSoePane === 'Details-NonSOE'
                      ? 'isselected'
                      : 'notselected'
                  }`}
                >
                  {i18n.t('non-SOE')}
                </button>
              </div>
              <br /> <br /> <br />
            </div>
            <div>
              <div className="table-responsive">
                <table className="table tableFC">
                  <thead>{this.renderSoeTableHeader()}</thead>
                  {this.renderSoeTableDetails()}
                </table>
              </div>
            </div>
            <br />
          </div>
        )}

        <CompText pane="Exposures" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    selectedSector: state.params.selectedSector,
    selectedCountry: state.params.selectedCountry,
    scrollCountry: state.params.scrollCountry,
    activeSoeDataType: state.params.activeSoeDataType,
    activeSoePane: state.params.activeSoePane,
  };
}

export default connect(mapStateToProps, {
  setSelectedSector,
  setSelectedCountry,
  resetScrollCountry,
  setActiveSoePane,
  setActiveSoeDataType,
})(Exposures);
